$(document).ready(function(){

  var thresold_value = $(".customVariantSelector").data("threshold-value");
  //console.log("Threshold VAlue =>", thresold_value);
  var globalCount = 0;
  var isBlackFriday = true;
  var selectElement = $(".selectorMain select");
  var sellingId = $(selectElement).find("option:first-child").val();
  //console.log("Selling Id =>", sellingId);

  var savingAmount = $(".savingFinalAmount").attr("data-saving-amount");
  var subscriptionPrice = $(".subscriptionPrice").attr("data-subscribe-price");
  var actualPrice = $(".actualProductPrice").attr("data-product-price");  
  var giftProductPrice = $(".giftProductPrice").attr("data-gift-price");  

  $('input[name="id"], input[name="selling_plan"]').remove();  

  //addTwoVariants();

  $(selectElement).on('change', function() {
    sellingId = this.value;
    //console.log("Selling Id =>", sellingId);
    if($('input[type="hidden"].firstVariantSellingId').length > 0){
      $('input[type="hidden"].firstVariantSellingId').val(sellingId);
    }
    if($('input[type="hidden"].secondVariantSellingId').length > 0){
      $('input[type="hidden"].secondVariantSellingId').val(sellingId);
    }
    if($('input[type="hidden"].thirdVariantSellingId').length > 0){
      $('input[type="hidden"].thirdVariantSellingId').val(sellingId);
    }
  });  
  
  $('.btnWithQty .addBtn').click(function(){
    $(this).addClass("hidden");
    $(this).next().removeClass("hidden");
    $(this).parents(".singleVariant").addClass("active");
    $(this).next().find(".quantity__input").val(1);
    globalCount = globalCount + 1;
    //console.log("Global Count =>", globalCount); 
    checkFreeShippingLabel(globalCount);


    showTotalAmount(globalCount, savingAmount, subscriptionPrice, actualPrice, giftProductPrice);
    // shippingThreshold(globalCount, subscriptionPrice);
    
    if(globalCount > 0){
      $('.product-form__buttons').addClass("active");
    }else{
      $('.product-form__buttons').removeClass("active")
    }    

    if(globalCount === 2 && isBlackFriday){
      $('.customWidget').addClass('bFridayActive');
      // console.log("Black Friday Should be On");
      // console.log("Black Friday Status =>", isBlackFriday);
      // console.log("Global Count =>", globalCount);
    }else{
      $('.customWidget').removeClass('bFridayActive');
      // console.log("Black Friday Should be Off");
      // console.log("Black Friday Status =>", isBlackFriday);
      // console.log("Global Count =>", globalCount);      
    }    
    
  });
  $('.quantity__button.plus').click(function () {		
    let thPlus = $(this).closest('.quantity').find('.quantity__input');    	
    thPlus.val(+thPlus.val() + 1);
    globalCount = globalCount + 1;
    //console.log("Global Count =>", globalCount);
    checkFreeShippingLabel(globalCount);
   
    showTotalAmount(globalCount, savingAmount, subscriptionPrice, actualPrice, giftProductPrice);
    // shippingThreshold(globalCount, subscriptionPrice);

    if(globalCount === 2 && isBlackFriday){
      $('.customWidget').addClass('bFridayActive');
      // console.log("Black Friday Should be On");
      // console.log("Black Friday Status =>", isBlackFriday);
      // console.log("Global Count =>", globalCount);
    }else{
      $('.customWidget').removeClass('bFridayActive');
      // console.log("Black Friday Should be Off");
      // console.log("Black Friday Status =>", isBlackFriday);
      // console.log("Global Count =>", globalCount);      
    } 
    
  });
  $('.quantity__button.minus').click(function () {
    let thMinus = $(this).closest('.quantity').find('.quantity__input');    	
    if (thMinus.val() > 0 && globalCount > 0){
      thMinus.val(+thMinus.val() - 1);
      globalCount = globalCount - 1;
      //console.log("Global Count =>", globalCount);
    }  
    if (thMinus.val() == 0){
      $(this).closest('.quantity').addClass("hidden");
      $(this).closest('.quantity').siblings(".addBtn").removeClass("hidden");
      $(this).parents(".singleVariant").removeClass("active");
    } 
    checkFreeShippingLabel(globalCount);
    
    showTotalAmount(globalCount, savingAmount, subscriptionPrice, actualPrice, giftProductPrice);  
    // shippingThreshold(globalCount, subscriptionPrice);
    if(globalCount > 0){
      $('.product-form__buttons').addClass("active");
    }else{
      $('.product-form__buttons').removeClass("active")
    }    

    if(globalCount === 2 && isBlackFriday){
      $('.customWidget').addClass('bFridayActive');
      // console.log("Black Friday Should be On");
      // console.log("Black Friday Status =>", isBlackFriday);
      // console.log("Global Count =>", globalCount);
    }else{
      $('.customWidget').removeClass('bFridayActive');
      // console.log("Black Friday Should be Off");
      // console.log("Black Friday Status =>", isBlackFriday);
      // console.log("Global Count =>", globalCount);      
    }     
    
  });  

  function checkFreeShippingLabel(count) {
    if(count >= thresold_value){
      $(".beforeFreeShipping").addClass("hidden");
      $(".afterFreeShipping").removeClass("hidden");
    }else{
      $(".beforeFreeShipping").removeClass("hidden");
      $(".afterFreeShipping").addClass("hidden");      
    }
  }
  

  function showTotalAmount(count, savingAmount, subscriptionPrice, actualPrice, giftProductPrice){

    if(count == 0){
      count = 1;
    }

    let finalSavingAmount = count * savingAmount;
    let finalSubscriptionPrice = count * subscriptionPrice;
    let finalProductPrice = count * actualPrice;
    let finalProductWithGift =  parseInt(finalProductPrice) + parseInt(giftProductPrice);

    $(".savingFinalAmount").text('$'+ finalSavingAmount);
    $(".subscriptionPrice").text('$'+ finalSubscriptionPrice);
    $(".actualProductPrice").text('$'+ finalProductPrice);
    $(".oldProductPrice").text('$'+ finalProductWithGift)
      
  }

  function shippingThreshold(count, subtotal) {


    let finalSubscriptionPrice = count * subtotal;    
  
    // Free Shipping Threshold Code Starts
    const freeShippingBar = document.getElementById("shippingBar");
    const remainingAmount = document.getElementById("remainingAmount");
    var remainingAmountParent = document.getElementById("remainingAmountParent");
    var gotFreeShipping = document.getElementById("gotFreeShipping");
    const thresholdValue = parseFloat(freeShippingBar.getAttribute("threshold"));  
    // console.log("Threshold Value =>", thresholdValue);
    // console.log("Sub Total =>", parseFloat(finalSubscriptionPrice));        
    freeShippingBar.style.setProperty("--progress", Math.min(parseFloat(finalSubscriptionPrice) / thresholdValue, 1));         
    const calculatedValue = thresholdValue - parseFloat(finalSubscriptionPrice) ;
    // console.log("Remaining Value =>", calculatedValue);
    if(calculatedValue > 0){
      remainingAmountParent.classList.remove("hide");
      gotFreeShipping.classList.add("hide");
      remainingAmount.innerHTML = '$' + calculatedValue;
    }else{
      remainingAmountParent.classList.add("hide");
      gotFreeShipping.classList.remove("hide");   
    }
    // Free Shipping Threshold Code Ends

    if(count > 0){
      $('#remainingAmountParent .prefix_text').text("You're");
      $('#remainingAmountParent p').html("away from <strong>FREE SHIPPING!</strong>");
    }else{
      $('#remainingAmountParent .prefix_text').text("Spend");
      $('#remainingAmountParent p').html("and get <strong>FREE SHIPPING!</strong>");      
    }    
  
  }
  


  // Add 1st two variants by default

  function addTwoVariants() {

    // First Variant
    var firstVariantId = $(".productVariant1").data("variant-id");
    var firstVariantQty = $(".qtyVariant1").val();    

    //console.log("FirstVariant Id =>", firstVariantId);
    //console.log("FirstVariant Qty =>", firstVariantQty);


    var classNamesToCheck = ['firstVariantId', 'firstVariantQty', 'firstVariantSellingId'];
  
    // Select the form where you want to check for the hidden inputs (replace 'form-selector' with your actual form selector)
    var $form = $('.product-form form');
  
    // Initialize a variable to keep track of the count of found inputs
    var foundCount = 0;
  
    // Loop through the class names and check if the corresponding hidden input exists
    classNamesToCheck.forEach(function(className) {
      var $hiddenInput = $form.find('input[type="hidden"].' + className);
      
      // If the hidden input with the specified class is found, increment the foundCount
      if ($hiddenInput.length > 0) {
        foundCount++;
      }
    });
  
    // Check if all three hidden inputs were found
    if (foundCount === 3) {
      // All three hidden inputs with the specified classes exist in the form
      //console.log("All hidden inputs found.");
    } else {

          var inputData = [
            { name: 'items[0][id]', class: 'firstVariantId', value: firstVariantId },
            { name: 'items[0][quantity]', class: 'firstVariantQty', value: firstVariantQty },
            { name: 'items[0][selling_plan]', class: 'firstVariantSellingId', value: sellingId }
          ];
      
          // Loop through the inputData array and create hidden input elements
          inputData.forEach(function(data) {
            var hiddenInput = $('<input>', {
              type: 'hidden',
              name: data.name,
              class: data.class,
              value: data.value
            });
      
            // Append the hidden input to the form
            $form.append(hiddenInput);
          });

          if($('.oneTimePurchase.active').length > 0) {
            $('input[type="hidden"].firstVariantSellingId').val('');     
          }       

      
      //console.log("Not all hidden inputs found.");
    }

    // Second Variant
    var secondVariantId = $(".productVariant2").data("variant-id");
    var secondVariantQty = $(".qtyVariant2").val();    

    //console.log("SecondVariant Id =>", secondVariantId);
    //console.log("SecondVariant Qty =>", secondVariantQty);


    var classNamesToCheck1 = ['secondVariantId', 'secondVariantQty', 'secondVariantSellingId'];
  
    // Select the form where you want to check for the hidden inputs (replace 'form-selector' with your actual form selector)
    var $form1 = $('.product-form form');
  
    // Initialize a variable to keep track of the count of found inputs
    var foundCount1 = 0;
  
    // Loop through the class names and check if the corresponding hidden input exists
    classNamesToCheck1.forEach(function(className) {
      var $hiddenInput1 = $form1.find('input[type="hidden"].' + className);
      
      // If the hidden input with the specified class is found, increment the foundCount
      if ($hiddenInput1.length > 0) {
        foundCount1++;
      }
    });
  
    // Check if all three hidden inputs were found
    if (foundCount1 === 3) {
      // All three hidden inputs with the specified classes exist in the form
      //console.log("All hidden inputs found.");
    } else {

          var inputData1 = [
            { name: 'items[1][id]', class: 'secondVariantId', value: secondVariantId },
            { name: 'items[1][quantity]', class: 'secondVariantQty', value: secondVariantQty },
            { name: 'items[1][selling_plan]', class: 'secondVariantSellingId', value: sellingId }
          ];
      
          // Loop through the inputData array and create hidden input elements
          inputData1.forEach(function(data) {
            var hiddenInput1 = $('<input>', {
              type: 'hidden',
              name: data.name,
              class: data.class,
              value: data.value
            });
      
            // Append the hidden input to the form
            $form1.append(hiddenInput1);
          });

          if($('.oneTimePurchase.active').length > 0) {
            $('input[type="hidden"].secondVariantSellingId').val('');     
          }       

      
      //console.log("Not all hidden inputs found.");
    }

    
  }


  // First Variant Selection
  $(".productVariant1").click(function(){
    var firstVariantId = $(this).data("variant-id");
    var firstVariantQty = $(".qtyVariant1").val();    

    //console.log("FirstVariant Id =>", firstVariantId);
    //console.log("FirstVariant Qty =>", firstVariantQty);


    var classNamesToCheck = ['firstVariantId', 'firstVariantQty', 'firstVariantSellingId'];
  
    // Select the form where you want to check for the hidden inputs (replace 'form-selector' with your actual form selector)
    var $form = $('.product-form form');
  
    // Initialize a variable to keep track of the count of found inputs
    var foundCount = 0;
  
    // Loop through the class names and check if the corresponding hidden input exists
    classNamesToCheck.forEach(function(className) {
      var $hiddenInput = $form.find('input[type="hidden"].' + className);
      
      // If the hidden input with the specified class is found, increment the foundCount
      if ($hiddenInput.length > 0) {
        foundCount++;
      }
    });
  
    // Check if all three hidden inputs were found
    if (foundCount === 3) {
      // All three hidden inputs with the specified classes exist in the form
      //console.log("All hidden inputs found.");
    } else {

          var inputData = [
            { name: 'items[0][id]', class: 'firstVariantId', value: firstVariantId },
            { name: 'items[0][quantity]', class: 'firstVariantQty', value: firstVariantQty },
            { name: 'items[0][selling_plan]', class: 'firstVariantSellingId', value: sellingId }
          ];
      
          // Loop through the inputData array and create hidden input elements
          inputData.forEach(function(data) {
            var hiddenInput = $('<input>', {
              type: 'hidden',
              name: data.name,
              class: data.class,
              value: data.value
            });
      
            // Append the hidden input to the form
            $form.append(hiddenInput);
          });

          if($('.oneTimePurchase.active').length > 0) {
            $('input[type="hidden"].firstVariantSellingId').val('');     
          }       

      
      //console.log("Not all hidden inputs found.");
    }
    
  });

  $(".quantitySelector1 .quantity__button").click(function(){
    let firstQtyValue = $(this).closest('.quantity').find('.quantity__input').val();
    if(firstQtyValue > 0){
      $('input[type="hidden"].firstVariantQty').val(firstQtyValue);
    }else{
      $('input[type="hidden"].firstVariantId, input[type="hidden"].firstVariantQty, input[type="hidden"].firstVariantSellingId').remove();  
    }    
  });

  $('.qtyVariant1').on('change', function() {
    if($(this).val() > 0){
      $('input[type="hidden"].firstVariantQty').val($(this).val());
    }else{
      $('input[type="hidden"].firstVariantId, input[type="hidden"].firstVariantQty, input[type="hidden"].firstVariantSellingId').remove();  
    }
  });



  // Second Variant Selection
  $(".productVariant2").click(function(){
    var secondVariantId = $(this).data("variant-id");
    var secondVariantQty = $(".qtyVariant2").val();    

    //console.log("SecondVariant Id =>", secondVariantId);
    //console.log("SecondVariant Qty =>", secondVariantQty);


    var classNamesToCheck1 = ['secondVariantId', 'secondVariantQty', 'secondVariantSellingId'];
  
    // Select the form where you want to check for the hidden inputs (replace 'form-selector' with your actual form selector)
    var $form1 = $('.product-form form');
  
    // Initialize a variable to keep track of the count of found inputs
    var foundCount1 = 0;
  
    // Loop through the class names and check if the corresponding hidden input exists
    classNamesToCheck1.forEach(function(className) {
      var $hiddenInput1 = $form1.find('input[type="hidden"].' + className);
      
      // If the hidden input with the specified class is found, increment the foundCount
      if ($hiddenInput1.length > 0) {
        foundCount1++;
      }
    });
  
    // Check if all three hidden inputs were found
    if (foundCount1 === 3) {
      // All three hidden inputs with the specified classes exist in the form
      //console.log("All hidden inputs found.");
    } else {

          var inputData1 = [
            { name: 'items[1][id]', class: 'secondVariantId', value: secondVariantId },
            { name: 'items[1][quantity]', class: 'secondVariantQty', value: secondVariantQty },
            { name: 'items[1][selling_plan]', class: 'secondVariantSellingId', value: sellingId }
          ];
      
          // Loop through the inputData array and create hidden input elements
          inputData1.forEach(function(data) {
            var hiddenInput1 = $('<input>', {
              type: 'hidden',
              name: data.name,
              class: data.class,
              value: data.value
            });
      
            // Append the hidden input to the form
            $form1.append(hiddenInput1);
          });

          if($('.oneTimePurchase.active').length > 0) {
            $('input[type="hidden"].secondVariantSellingId').val('');     
          }       

      
      //console.log("Not all hidden inputs found.");
    }
    
  });

  $(".quantitySelector2 .quantity__button").click(function(){
    let secondQtyValue = $(this).closest('.quantity').find('.quantity__input').val();
    if(secondQtyValue > 0){
      $('input[type="hidden"].secondVariantQty').val(secondQtyValue);
    }else{
      $('input[type="hidden"].secondVariantId, input[type="hidden"].secondVariantQty, input[type="hidden"].secondVariantSellingId').remove();  
    }    
  });

  $('.qtyVariant2').on('change', function() {
    if($(this).val() > 0){
      $('input[type="hidden"].secondVariantQty').val($(this).val());
    }else{
      $('input[type="hidden"].secondVariantId, input[type="hidden"].secondVariantQty, input[type="hidden"].secondVariantSellingId').remove();  
    }
  });
  


  // Third Variant Selection
  $(".productVariant3").click(function(){
    var thirdVariantId = $(this).data("variant-id");
    var thirdVariantQty = $(".qtyVariant3").val();    

    //console.log("ThirdVariant Id =>", thirdVariantId);
    //console.log("ThirdVariant Qty =>", thirdVariantQty);


    var classNamesToCheck2 = ['thirdVariantId', 'thirdVariantQty', 'thirdVariantSellingId'];
  
    // Select the form where you want to check for the hidden inputs (replace 'form-selector' with your actual form selector)
    var $form2 = $('.product-form form');
  
    // Initialize a variable to keep track of the count of found inputs
    var foundCount2 = 0;
  
    // Loop through the class names and check if the corresponding hidden input exists
    classNamesToCheck2.forEach(function(className) {
      var $hiddenInput2 = $form2.find('input[type="hidden"].' + className);
      
      // If the hidden input with the specified class is found, increment the foundCount
      if ($hiddenInput2.length > 0) {
        foundCount2++;
      }
    });
  
    // Check if all three hidden inputs were found
    if (foundCount2 === 3) {
      // All three hidden inputs with the specified classes exist in the form
      //console.log("All hidden inputs found.");
    } else {

          var inputData2 = [
            { name: 'items[2][id]', class: 'thirdVariantId', value: thirdVariantId },
            { name: 'items[2][quantity]', class: 'thirdVariantQty', value: thirdVariantQty },
            { name: 'items[2][selling_plan]', class: 'thirdVariantSellingId', value: sellingId }
          ];
      
          // Loop through the inputData array and create hidden input elements
          inputData2.forEach(function(data) {
            var hiddenInput2 = $('<input>', {
              type: 'hidden',
              name: data.name,
              class: data.class,
              value: data.value
            });
      
            // Append the hidden input to the form
            $form2.append(hiddenInput2);
          });

          if($('.oneTimePurchase.active').length > 0) {
            $('input[type="hidden"].thirdVariantSellingId').val('');     
          }      

      
      //console.log("Not all hidden inputs found.");
    }
    
  });

  $(".quantitySelector3 .quantity__button").click(function(){
    let thirdQtyValue = $(this).closest('.quantity').find('.quantity__input').val();
    if(thirdQtyValue > 0){
      $('input[type="hidden"].thirdVariantQty').val(thirdQtyValue);
    }else{
      $('input[type="hidden"].thirdVariantId, input[type="hidden"].thirdVariantQty, input[type="hidden"].thirdVariantSellingId').remove();  
    }    
  });

  $('.qtyVariant3').on('change', function() {
    if($(this).val() > 0){
      $('input[type="hidden"].thirdVariantQty').val($(this).val());
    }else{
      $('input[type="hidden"].thirdVariantId, input[type="hidden"].thirdVariantQty, input[type="hidden"].thirdVariantSellingId').remove();  
    }
  });
  

  // One Time Purchase

  $(".oneTimePurchase").click(function(){
    $(".subAndSave").removeClass("active");
    $(this).addClass("active");
    $(".ifSubscribe").addClass("hidden");
    $(".ifOneTime").removeClass("hidden");
    if($('input[type="hidden"].firstVariantSellingId').length > 0){
      $('input[type="hidden"].firstVariantSellingId').val('');
    }
    if($('input[type="hidden"].secondVariantSellingId').length > 0){
      $('input[type="hidden"].secondVariantSellingId').val('');
    }
    if($('input[type="hidden"].thirdVariantSellingId').length > 0){
      $('input[type="hidden"].thirdVariantSellingId').val('');
    }    
  });

  // Subscribe And Save
  $(".subAndSave").click(function(){
    $(".oneTimePurchase").removeClass("active");
    $(this).addClass("active");
    $(".ifSubscribe").removeClass("hidden");
    $(".ifOneTime").addClass("hidden");    
    if($('input[type="hidden"].firstVariantSellingId').length > 0){
      $('input[type="hidden"].firstVariantSellingId').val(sellingId);
    }
    if($('input[type="hidden"].secondVariantSellingId').length > 0){
      $('input[type="hidden"].secondVariantSellingId').val(sellingId);
    }
    if($('input[type="hidden"].thirdVariantSellingId').length > 0){
      $('input[type="hidden"].thirdVariantSellingId').val(sellingId);
    }    
  });  


});